<template>
  <v-footer dark padless>
    <v-card width="100%" flat tile class="black white--text text-center">
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          class="mt-4 ml-4 white--text"
          icon
          :href="icon.url"
          target="_blank"
        >
          <v-icon size="36px">{{ icon.icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="mt-0 pt-0 mb-2 amber--text accent-2--text">
        {{ new Date().getFullYear() }} —
        <strong>Butch Escobar</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: function() {
    return {
      icons: [
        {
          icon: "fab fa-facebook",
          url: "https://www.facebook.com/escobarbutch"
        },
        {
          icon: "fab fa-twitter",
          url: "https://twitter.com/butchescobar?lang=en"
        },
        {
          icon: "fab fa-youtube",
          url: "https://www.youtube.com/user/butchescobar"
        },
        {
          icon: "fas fa-video",
          url: "https://www.tiktok.com/@butchescobar?"
        }
      ]
    };
  }
};
</script>
